module.exports = __webpack_public_path__ + "img/work5.71a12750.png";